import { useInterceptor } from '@/components/AuthInterceptorComponent/hooks/useInterceptor';
import { useLoading } from '@/context/LoadingContext';
import { useEffect } from 'react';

export const AuthInterceptorComponent = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { enableRender } = useInterceptor();
  const { setLoading } = useLoading();

  useEffect(() => {
    if (!enableRender) {
      setLoading(true, 'AuthInterceptor');
    } else {
      setLoading(false, 'AuthInterceptor');
    }
  }, [enableRender, setLoading]);

  if (!enableRender) {
    return null; // Slim loader will show at top
  }
  return <div>{children}</div>;
};
